module.exports = __webpack_public_path__ + "static/media/location-demo.41c50f53.png";